import { IconSearch } from "@tabler/icons-react";
import type { FC } from "react";
import { Button as AriaButton } from "react-aria-components";
import { navigationMenuItem } from "../../app/navigation/menu/navigationMenuItem.js";

export interface NavigationSearchItemProps {
  isActive?: boolean;
  onPress?: () => void;
}

/**
 * Search entry styled as a nav menu item. Used as the trigger inside a
 * react-aria `DialogTrigger` (see `NavigationSearchContainer`), where it picks
 * up press handling from context, so `onPress` is only needed standalone.
 */
export const NavigationSearchItem: FC<NavigationSearchItemProps> = ({
  isActive = false,
  onPress,
}) => {
  const styles = navigationMenuItem({ isActive });

  return (
    <AriaButton
      aria-label="Open search"
      onPress={onPress}
      className={styles.root()}
    >
      <span className={styles.icon()}>
        <IconSearch aria-hidden className="size-4" />
      </span>
      <span className={styles.label()}>Search</span>
    </AriaButton>
  );
};
